import React, { useState } from 'react';
import { SectionConfig, FieldMapping } from '../../types/metadata';
import { SectionSidebar } from './SectionSidebar';
import { FieldMappingList } from './FieldMappingList';
interface FieldMappingPanelProps {
  sections: SectionConfig[];
  fields: FieldMapping[];
  getFieldCount: (key: string) => number;
  getOptionCount: (key: string) => number;
  onAdd: (field: Omit<FieldMapping, 'id'>) => void;
  onUpdate: (id: string, updates: Partial<FieldMapping>) => void;
  onDelete: (id: string) => void;
  onReorder: (id: string, direction: 'up' | 'down') => void;
}
export function FieldMappingPanel({
  sections,
  fields,
  getFieldCount,
  getOptionCount,
  onAdd,
  onUpdate,
  onDelete,
  onReorder
}: FieldMappingPanelProps) {
  const [selectedSectionKey, setSelectedSectionKey] = useState<string | null>(null);
  return <div className="flex flex-col md:flex-row gap-6" data-id="element-152">
      <SectionSidebar sections={sections} selectedSectionKey={selectedSectionKey} onSelectSection={setSelectedSectionKey} getFieldCount={getFieldCount} data-id="element-153" />
      <FieldMappingList fields={fields} sections={sections} selectedSectionKey={selectedSectionKey} getOptionCount={getOptionCount} onAdd={onAdd} onUpdate={onUpdate} onDelete={onDelete} onReorder={onReorder} data-id="element-154" />
    </div>;
}